export default __webpack_public_path__ + "static/media/cloud_icon_01_white.20fb75e5.svg";